import { createFileRoute } from "@tanstack/react-router";
import { MigrationsPage } from "@/components/Migrations";

function RouteComponent() {
  return <MigrationsPage />;
}

export const Route = createFileRoute("/_authenticated/migrations/")({
  component: RouteComponent,
  staticData: { page: "admin" },
});
